import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breakpointCodes } from 'rp-mq-breakpoints';
import DataTable from './GridDataTable';
import DropDown from '../modules/Dropdown';
import tableConfig from '../config/statisticsCataloguesTable';
import filterConfig from '../config/statisticsCataloguesFilter';
import { updateTableOnFilterChange, initialTableUpdate } from '../helpers/dispatchProps';

const { EXTRA_NARROW, NARROW } = breakpointCodes;
/**
 * Reducer state key
 * @type {string}
 */
const stateKey = 'statistics';

/**
 * Statistics page
 *
 * @param {{}} props
 * @constructor
 */
function StatisticsCatalogues(props) {
    function colSpanGetter(breakpoint) {
        switch (breakpoint) {
            case EXTRA_NARROW:
                return 4;
            case NARROW:
                return 6;
            default:
                return 10;
        }
    }
    return (
        <div className="table__CataloguesList table__CataloguesListStatistics">
            <div className="sales__filter">
                <DropDown
                    stateKey={stateKey}
                    errorMessage="No sales found"
                    onSelect={props.onFilterSelect}
                    {...filterConfig}
                />
            </div>
            <DataTable
                stateKey={stateKey}
                config={tableConfig}
                colSpanGetter={colSpanGetter}
                onMount={initialTableUpdate(tableConfig.url)}
            />
        </div>
    );
}

StatisticsCatalogues.propTypes = {
    /**
     * Filter onSelect event handler
     * Dispatch prop
     */
    onFilterSelect: PropTypes.func
};

/**
 * Create component properties based on app state
 * No state props for this component
 *
 * @returns {{}} Empty object
 */
function mapStateToProps() {
    return {};
}

/**
 * Create component callable properties
 *
 * @returns {{}} Properties
 */
function mapDispatchToProps() {
    return {
        onFilterSelect: updateTableOnFilterChange(stateKey, tableConfig.url)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsCatalogues);



// WEBPACK FOOTER //
// ./src/js/containers/StatisticsCatalogues.js